<template>
  <td>
    <b-form-checkbox :disabled="dataItem.isEdit"  v-model="dataItem.selected" name="checkbox-1" @change="clickHandler"></b-form-checkbox>
  </td>
</template>
 
<script>
// import { mapState } from "vuex";
export default {
  props: {
    dataItem: Object,
    faceId: Number,
    columnIndex: Number,
    sortable: [Boolean, Object],
  },
  methods: {
    clickHandler: function (e) {
      console.log("e", e);
      this.$emit("checkItem", { selected: e, id: this.dataItem.id });
    },
  },
  // mounted() {
  //   this.getDataOnload();
  // },

  //   created() {
  //     this.getDataOnload();
  //   },
  //   watch: {
  //     dataItem: function (newVal) {
  //       this.id = this.facility.find((obj) => obj.id == newVal.facilityID);
  //       this.item = newVal;
  //     },
  //   },

  data: function () {
    return {
      item: { ...this.dataItem },

      selectAll: false,
    };
  },
};
</script>
 
<style>
</style>